/**
 * Vehicle taxonomy.
 *
 * Engins BTP are modelled as a first-class vehicle class rather than a flag on a
 * car, because almost every downstream calculation forks on it: usage is measured
 * in engine hours instead of kilometres, efficiency is L/h instead of L/100km,
 * maintenance is scheduled on the hour-meter, and "stationary with the engine
 * running" is productive work rather than wasteful idling.
 */
export const VEHICLE_CLASSES = ['car', 'van', 'truck', 'machine'];
export const MACHINE_SUBTYPES = [
    'excavator', // pelle
    'loader', // chargeuse
    'bulldozer', // bulldozer
    'grader', // niveleuse
    'compactor', // compacteur
    'dumper', // tombereau
    'crane', // grue
    'forklift', // chariot élévateur
    'generator', // groupe électrogène
    'other',
];
export function usageMetricFor(vehicleClass) {
    return vehicleClass === 'machine' ? 'engine_hours' : 'distance';
}
export function consumptionUnitFor(vehicleClass) {
    return vehicleClass === 'machine' ? 'l_per_hour' : 'l_per_100km';
}
export const FUEL_TYPES = ['diesel', 'gasoline', 'lpg', 'electric', 'hybrid'];
/**
 * Well-known emission factors, kg CO₂ per litre burned, for the fleet CO₂ estimate
 * in the fuel dashboard (§8.3). Electric is zero here because tank-to-wheel is what
 * fuel-burn reporting measures; a well-to-wheel figure would need a grid factor and
 * is deliberately not claimed.
 */
export const CO2_KG_PER_LITRE = {
    diesel: 2.68,
    gasoline: 2.31,
    lpg: 1.61,
    electric: 0,
    hybrid: 2.31,
};
/**
 * How a device is wired, which decides whether ignition is trustworthy.
 *
 * On an OBD-II install there is usually no DIN1 ignition wire, so ignition has to
 * be inferred from external voltage and movement. Trip building and idling
 * detection both need to know which case they are in — an inferred ignition is not
 * as sharp as a wired one and the UI says so.
 */
export const INSTALL_TYPES = ['hardwired', 'obd', 'unknown'];
export function isMachine(v) {
    return v.vehicleClass === 'machine';
}
/** Display label falls back to the registration when make/model are unknown. */
export function vehicleDisplayName(v) {
    const makeModel = [v.make, v.model].filter(Boolean).join(' ').trim();
    return makeModel.length > 0 ? `${v.registration} — ${makeModel}` : v.registration;
}
//# sourceMappingURL=vehicle.js.map